import React from 'react';
import { Link } from 'react-router-dom';

/**
 * TODO:
 * Refactor this component to be reusable. Incorrect User, notauthorized and notRegistered components are similar
 */
const IncorrectUser: React.FC<{}> = () => {
    return <div className="container text-center mt-5">
    <h1 className="display-4">Incorrect User!</h1>
    <p className="lead">The user you entered and selected are not the same.</p>
    <p>Please contact the administrator for assistance.</p>
    <Link to="/" >Go to login</Link>
  </div>;
  };

export default IncorrectUser;